var React = require('react');

function Bone (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M598.88 244.56a12.79 12.79 0 0 0 0 22.88A74.38 74.38 0 0 1 640 334v7.64a74.38 74.38 0 0 1-145 23.5c-6.53-19.6-10.73-45.14-38.11-45.14H183.06c-26.51 0-30.43 22.11-38.11 45.14A74.38 74.38 0 0 1 0 341.61V334a74.39 74.39 0 0 1 41.12-66.53 12.79 12.79 0 0 0 0-22.88A74.39 74.39 0 0 1 0 178v-7.64a74.38 74.38 0 0 1 145-23.53c6.53 19.6 10.73 45.14 38.11 45.14h273.82c26.51 0 30.43-22.11 38.11-45.14a74.39 74.39 0 0 1 145 23.53V178a74.39 74.39 0 0 1-41.12 66.53z","className":"fa-secondary","key":1})]);
}

Bone.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = Bone;

Bone.default = Bone;
